module.exports = __webpack_public_path__ + "static/media/5v5ideLogoBlack.2003723b.png";